'use strict'

import Axios from 'axios';
import configuration from "../../configuration";

const url = configuration.apiHost + "products";

export default class ProductService {

  static validade(product) {
    let errors = []
    if (!product.category) errors.push('categoria')
    if (!product.description) errors.push('descrição')
    if (!product.unity) errors.push('unidade de medida')
    if (!product.value) errors.push('valor unitário')

    if (errors.length > 0) return errors
    else return null
  }

  static async getAll() {
    try {
      let products = await Axios.get(url);
      return products.data;
    } catch (error) {
      throw error.response.data;
    }
  } // getAll()

  static async getByCategory(type) {
    try {
      let products = await Axios.post(url + "/getByCategory", type);
      return products.data;
    } catch (error) {
      throw error.response.data;
    }
  }

  static async save(product) {
    try {
      let productSaved = await Axios.post(url, product);
      return productSaved.data;
    } catch (error) {
      throw error.response.data;
    }
  } // save()

  static async update(product) {
    try {
      let productUpdated = await Axios.put(url, product);
      return productUpdated.data;
    } catch (error) {
      throw error.response.data;
    }
  } // update()

  static async remove(product) {
    try {
      await Axios.delete(url, {
        data: product
      });
    } catch (error) {
      throw error.response.data;
    }
  } // remove()
} // class



// WEBPACK FOOTER //
// ./src/service/ProductService.js